/**
 * The reason a Supabase/PostgREST call failed, for the tail of a toast.
 * A bare "נסה שוב" hid the RLS failure behind every delete for months; the
 * raw message is ugly but it is the thing that gets a bug reported.
 */
export function errorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err && typeof err.message === 'string') {
    return err.message;
  }
  return String(err);
}
